// export const apiHostName = 'http://192.168.0.102:5001';
// export const apiHostName = `${window.location.protocol}//${window.location.hostname}:5001`;
// export const apiHostName = 'https://localhost:44347';
export const apiHostName = 'https://autorobodnz-001-site1.mtempurl.com';   //shark asp paid/¿



export const host = 'http://localhost:3009'
export const authority = "http://api.mansurtraders.com";


